var en_CA = {};
module['exports'] = en_CA;
en_CA.title = "Canada (English)";
en_CA.address = require("./address");
en_CA.internet = require("./internet");
en_CA.phone_number = require("./phone_number");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/index.js
// module id = 441
// module chunks = 0